import type { DividedAcquisitionNumberProps } from 'BrokerTsLib/src/dtos'
import type { Partner } from 'BrokerTsLib/src/enums'
import { Insurer } from 'BrokerTsLib/src/enums'

import { usePartner } from '@/context/PartnerContext'


const JapDividedAcquisitionNumbers: [Insurer, DividedAcquisitionNumberProps[]][] = [
  [Insurer.Allianz, [{ index: 0, label: 'Agent č.1' }, { index: 1, label: 'Agent č.2' }, { index: 2, label: 'Agent č.3' }]],
  [Insurer.Kooperativa, [{ index: 0, label: 'AutoKAM' }, { index: 1, label: 'Fiktiv' }]],
]

const GetDividedAcquitisionNumbers = (partner?: keyof typeof Partner) => {
  switch (partner) {
    case 'Jap':
      return JapDividedAcquisitionNumbers

    default:
      return []
  }
}

const useDividedAcquisitionNumbers = () => {
  const { currentPartner } = usePartner()

  const DividedAcquisitionNumbers = GetDividedAcquitisionNumbers(currentPartner?.partner)

  return DividedAcquisitionNumbers
}

export const useAcquisitionNumber = (insurer: Insurer, value?: string, isDividedDisabled?: boolean) => {
  const dividedAcquisitionNumbers = useDividedAcquisitionNumbers()
  const segments = (isDividedDisabled
    ? undefined
    : dividedAcquisitionNumbers.find(
      ([x]) => x === insurer,
    )?.[1]) ?? [{ index: 0, label: '' }]

  const values = segments?.length > 1 ? value?.split('/') : [value]

  return {
    segments,
    values
  } as const
}